import React, { useEffect, useState } from 'react';
import { Form, FormInstance } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  Input,
  // InputNumber,
  Modal,
  Select,
} from 'UI';
import { OrganizationEnum, OrganizationMapping } from 'constants/organization';

import {
  FormContainer,
  BaseFormItem,
  InlineButton,
  InlineFormGroup,
  // CapacityInput,
  BenchTitle,
  BenchFormItem,
  AddBenchButton,
  RemoveBenchButton,
  RemoveBenchIcon,
  BenchFormRow,
} from './style';

export interface GreenhouseFormData {
  name: string
  organization: OrganizationEnum
  benches: {
    sequenceNumber: number,
    capacity: string,
  }[]
}

interface ModalGreenhouse {
  name: string
  organization: OrganizationEnum
  benches: {
    sequenceNumber: number,
    capacity: number,
  }[]
}

interface GreenhouseModalProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  onCancel(): void
  curGreenhouse?: ModalGreenhouse
  isLoading: boolean
  isVisible: boolean
}

const GreenhouseModal = ({
  formHandler,
  onSubmit,
  onCancel,
  curGreenhouse,
  isLoading,
  isVisible,
}: GreenhouseModalProps): JSX.Element => {
  const [benches, setBenches] = useState(curGreenhouse?.benches);

  useEffect(() => {
    setBenches(curGreenhouse?.benches);
  }, [curGreenhouse]);

  return (
    <Modal
      visible={isVisible}
      title={curGreenhouse ? 'Editar estufa' : 'Nova estufa'}
      destroyOnClose
      onCancel={onCancel}
      afterClose={onCancel}
      zIndex={90}
      footer={[
        <InlineButton
          key="cancel"
          onClick={onCancel}
          type="ghost"
        >
          Cancelar
        </InlineButton>,
        <InlineButton
          key="submit"
          onClick={onSubmit}
          disabled={isLoading}
          loading={isLoading}
        >
          Salvar estufa
        </InlineButton>,
      ]}
    >
      <FormContainer
        layout="vertical"
        form={formHandler}
        requiredMark={false}
        onFinish={onSubmit as (val: unknown) => void}
      >
        <InlineFormGroup>
          <BaseFormItem
            label="Nome"
            name="name"
            rules={[
              {
                required: true,
                message: 'Insira um nome',
              },
            ]}
            initialValue={curGreenhouse?.name}
          >
            <Input disabled={isLoading} />
          </BaseFormItem>
          <BaseFormItem
            label="Unidade"
            name="organization"
            rules={[
              {
                required: true,
                message: 'Selecione uma unidade',
              },
            ]}
            initialValue={curGreenhouse?.organization || OrganizationEnum.ORG1}
          >
            <Select
              disabled={isLoading}
              className="organization-input"
            >
              {Object.values(OrganizationEnum).map((val) => (
                <Select.Option value={val} key={val}>
                  {OrganizationMapping[val].name}
                </Select.Option>
              ))}
            </Select>
          </BaseFormItem>
        </InlineFormGroup>
        {/* <BaseFormItem
          label="Capacidade"
          name="capacity"
          initialValue={benches?.reduce((acc, curBench) => (curBench.capacity + acc), 0)}
        >
          <CapacityInput type="number" min={0} disabled suffix="Bandejas" />
        </BaseFormItem> */}
        {/* <CapacityInput type="number" min={0} disabled suffix="Bandejas" /> */}
        <BenchTitle>Bancas</BenchTitle>
        <Form.List
          name="benches"
          initialValue={benches}
        >
          {(fields, { add, remove }) => (
            <>
              {fields.map((benchField, index) => (
                <BenchFormRow
                  key={benchField.key}
                >
                  <BenchFormItem
                    label={`Banca ${index + 1}`}
                    name={[benchField.name, 'capacity']}
                    rules={[
                      {
                        required: true,
                        message: 'Insira uma capacidade',
                      },
                    ]}
                  >
                    <Input type="number" min={0} suffix="Bandejas" disabled={isLoading} />
                  </BenchFormItem>
                  <RemoveBenchButton onClick={() => remove(index)}>
                    <RemoveBenchIcon />
                  </RemoveBenchButton>
                </BenchFormRow>
              ))}
              <AddBenchButton
                type="dashed"
                onClick={() => add({
                  sequenceNumber: fields.length + 1,
                  capacity: undefined,
                }, fields.length)}
                icon={<PlusOutlined size={14} />}
              >
                Adicionar banca
              </AddBenchButton>
            </>
          )}
        </Form.List>
      </FormContainer>
    </Modal>
  );
};

GreenhouseModal.defaultProps = {
  curGreenhouse: undefined,
};

export default GreenhouseModal;
